/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'link': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M115.625 127.937H.063V12.375h57.781v12.374H12.438v90.813h90.813V70.156h12.374z"/><path pid="1" d="M116.426 2.821l8.753 8.753-56.734 56.734-8.753-8.745z"/><path pid="2" d="M127.893 37.982h-12.375V12.375H88.706V0h39.187z"/>'
  }
})
